export const phoneNumberFormat = (phoneNumber: any) => {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '')
  const celMatch = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/)
  const telMatch = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/)
  if (celMatch) {
    return '(' + celMatch[1] + ') ' + celMatch[2] + '-' + celMatch[3]
  }
  if (telMatch) {
    return '(' + telMatch[1] + ') ' + telMatch[2] + '-' + telMatch[3]
  }
  return null
}
